import { BookingStatusEnum } from '../../booking-request';

export interface GroupedBarChartData {
  group: string | Date;
  [key: string]: string | number | Date;
}

export interface GroupedBarChartConfig {
  colors?: readonly string[];
  margin?: { top: number; right: number; bottom: number; left: number };
  showSubgroupValues?: boolean;
  showGridLines?: boolean;
  showLegend?: boolean;
  legendWidth?: number;
  orientation?: 'vertical' | 'horizontal';
  showSubgroupLabels?: boolean;
  hideZeroValues?: boolean;
  minSvgWidth?: number;
  title?: string;
}

export interface BarAttributes {
  x: number;
  y: number;
  width: number;
  height: number;
  fill: string;
  valueX: number;
  valueY: number;
  anchor: string;
}

export const bluePalette: readonly string[] = [
  '#D7E0F7',
  '#90ABF1',
  '#6084E2',
  '#3461D5',
  '#0B41CD',
  '#0936AB',
  '#072B89',
  '#022366',
  '#011745',
];
export const defaultConfig: Required<GroupedBarChartConfig> = {
  colors: bluePalette,
  margin: { top: 20, right: 10, bottom: 30, left: 30 },
  showSubgroupValues: true,
  showGridLines: true,
  showLegend: true,
  legendWidth: 120,
  orientation: 'vertical',
  showSubgroupLabels: false,
  hideZeroValues: false,
  minSvgWidth: 365,
  title: '',
};

export enum EventType {
  CONFERENCE = 'Conference',
  WORKSHOP = 'Workshop',
  SEMINAR = 'Seminar',
  MEETING = 'Meeting',
  TRAINING = 'Training',
  TOWN_HALL = 'Town Hall',
  CELEBRATION = 'Celebration',
}

export interface PieChartData {
  label: string;
  value: number;
}

export interface PieChartConfig {
  colors?: readonly string[];
  margin?: { top: number; right: number; bottom: number; left: number };
  showLegend?: boolean;
  title?: string;
}

export const defaultConfigPie: Required<PieChartConfig> = {
  colors: bluePalette,
  margin: { top: 20, right: 20, bottom: 20, left: 20 },
  showLegend: true,
  title: '',
};
export interface BookingChartDataDTO {
  id: number;
  roomDexId: string;
  eventName: string;
  eventType: EventType;
  numberOfPeople: number;
  wbsCode: string;
  costCenter: string;
  userEmail: string;
  onBehalfEmail: string;
  startTime: Date;
  endTime: Date;
  createTime: Date;
  status: BookingStatusEnum;
  isReapproved?: boolean;
  message: string;
  roomName: string;
  roomNumber: string;
  roomType: string;
  capacity: number;
  minCapacity: number;
  siteName: string;
  buildingName: string;
  buildingNumber: string;
  services: string;
  roomLayoutName: string;
  setupBeforeMinutes: number;
  setupAfterMinutes: number;
  cecOnSite: boolean;
  hcpOnSite: boolean;
  moreThan20Externals: boolean;
  additionalInfo: string;
  weekNumber: number;
  month: number;
  year: number;
  quarter: number;
}

export interface ChartSearchParams {
  fromDate?: string;
  toDate?: string;
  weekNumber?: number;
  month?: number;
  year?: number;
  quarter?: number;
}

export interface BookingChartTableRowDTO {
  id: number;
  eventName: string;
  startTime: Date;
  endTime: Date;
  createTime: Date;
  numberOfPeople: number;
  roomType: string;
  roomName: string;
  status: BookingStatusEnum;
  services: string;
}

export interface CalculatedChartDataDTO {
  countPerMonthRT: GroupedBarChartData[];
  averagePerWeekday: GroupedBarChartData[];
  averagePeoplePerRoomType: GroupedBarChartData[];
  countPerStatus: PieChartData[];
}

export interface BookingStatsDTO {
  totalBookingsToday: number;
  totalBookingsWeekdayWeekBefore: number;
  bookingsChangePercentage: number;
  totalBookingsThisMonth: number;
  totalBookingsPreviousMonth: number;
  bookingsChangePercentageThisMonth: number;
  averageDurationThisMonth: number;
  averageDurationPreviousMonth: number;
  averageDurationChange: number;
}
